// extracted by mini-css-extract-plugin
export default {"discountBanner":"uR","topheader":"vR","navleft":"wR","navflexelem":"xR","navright":"yR","fixedtop":"zR","checkout_header_wrapper":"AR","hideBanner":"BR","abstop":"CR","subdesc":"ER","smallscreennav":"FR","nav_hidden":"GR","cancel_link":"HR","bottomnavcontainer":"IR","fixedbottom":"JR","animatedbottom":"KR","appear-bottom":"LR","delayedbottom":"MR","long_banner":"NR","nofixed":"OR","black_friday":"PR"};
    if(module.hot) {
      // 1715632478657
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  